import React from 'react';
import '../../styles/design-system.css';

/**
 * Badge Component
 * Status badge matching iLovePDF design
 * 
 * @param {Object} props
 * @param {string} props.variant - 'primary' | 'success' | 'warning' | 'error' | 'info' | 'neutral'
 * @param {React.ReactNode} props.children - Badge content
 */
const Badge = ({
    variant = 'neutral',
    children,
    className = '',
    ...props
}) => {
    const classes = [
        'badge',
        `badge-${variant}`,
        className
    ].filter(Boolean).join(' ');

    return (
        <span className={classes} {...props}>
            {children}
        </span>
    );
};

export default Badge;
